import React, { useState, useEffect } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
import "./PayRollGenerator.css";

const PayRollGenerator = () => {

    const empcode = localStorage.getItem('empcode');

    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const [plants, setPlants] = useState([]);
    const [company, setCompany] = useState([]);
    const [vender, setVender] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // NEW
    const [statusFilter, setStatusFilter] = useState("ALL"); // NEW
    const { setLoading } = useLoading();

    const [filters, setFilters] = useState({
        CompanyName: '',
        PlantName: '',
        VenderName: '',
        EmployeeCode: '',
        MonthYear: ''
    });

    useEffect(() => {
        loadDropdowns();
    }, []);

    useEffect(() => {
        applyStatusFilter(statusFilter);
    }, [data]);

    const loadDropdowns = async () => {
        try {
            const [plantRes, companyRes, venderRes] = await Promise.all([
                EmployeeProcessService.getPlant(empcode),
                EmployeeProcessService.getCompany('User'),
                EmployeeProcessService.getVender('User')
            ]);

            if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
            if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);

        } catch (error) {
            console.error(error);
        }
    };

    const handleMonthChange = (e) => {
        const [year, month] = e.target.value.split("-");
        setFilters(prev => ({ ...prev, MonthYear: `${month}${year}` }));
    };

    const fetchData = async () => {
        try {
            setLoading(true);

            const res = await EmployeeProcessService.getPayRollGenerator({
                ...filters,
                EmployeeCode: filters.EmployeeCode?.trim()
            });

            if (res.data.statusCode === 200) {
                setData(res.data.result || []);
                setSelectedRows([]);
                setFilteredData(res.data.result);
                setSelectAll(false);
            } else {
                setData([]);
                setFilteredData([]);
                toast.info("No records found");
            }

        } catch {
            toast.error("Error fetching data");
        } finally {
            setLoading(false);
        }
    };

    const applyFilters = () => {
        if (!filters.MonthYear) return alert("Select month");
        fetchData();
    };

    // NEW STATUS FILTER
    const applyStatusFilter = (type) => {
        setStatusFilter(type);

        if (type === "OPEN") {
            setLoading(true);
            setFilteredData(data.filter(x => x.isLock !== 1 && x.isLock !== "1"));
            setLoading(false);
        }
        else if (type === "LOCKED") {
            setLoading(true);
            setFilteredData(data.filter(x => x.isLock === 1 || x.isLock === "1"));
            setLoading(false);
        }
        else {
            setLoading(true);
            setFilteredData(data);
            setLoading(false);
        }

        setSelectedRows([]);
        setSelectAll(false);
    };
    // ✅ SELECT ALL
    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.filter(d => d.isLock !== 1).map(d => d.code));
        }
        setSelectAll(!selectAll);
    };



    // ✅ ROW SELECT
    const handleRowSelect = (code) => {
        const row = data.find(d => d.code === code);
        if (row?.isLock === 1) return;

        const updated = selectedRows.includes(code)
            ? selectedRows.filter(x => x !== code)
            : [...selectedRows, code];

        setSelectedRows(updated);
    };

    // ✅ LOCK SELECTED
    const handleLockSelected = async () => {
        if (selectedRows.length === 0) return alert("Select employees first");

        try {
            setLoading(true);
            // Selected employee full data
            const selectedEmployeeData = data
                .filter(x => selectedRows.includes(x.code))
                .map(row => ({
                    EmployeeCode: row.code,
                    TotDays: row.totDays || 0,
                    PresentDays: row.presentDays || 0,
                    Absent: row.absent|| 0,
                    PaidLeave: row.paidLeave || 0,
                    HalfDay: row.halfDay || 0,
                    WO: row.wo || 0,
                    Holiday: row.holiday || 0, 
                    TotalPaidDays: row.totalPaidDays || 0,
                    Expected: row.expected || 0,
                    Actual: row.actual || 0,
                    Deducted: row.deducted || 0,
                    TotalHours: row.totalHours || 0,
                    Incentive: row.incentive || 0,
                    PendingLeave: row.pendingLeave,
                    PendingAR: row.pendingAR || 0,
                    ArrearDays: row.arrearDays || 0,
                    PendingOD: row.pendingOD || 0,
                    Sandwich: row.sandwich || 0
                }));

            // ✅ FormData
            const formData = new FormData();

            formData.append("MonthYear", filters.MonthYear);

            // send payroll json separately
            formData.append(
                "PayrollData",
                JSON.stringify(selectedEmployeeData)
            );

            const response =
                await EmployeeProcessService.setSelectedLockPayroll(formData);

            if (response.success && response.data.statusCode === 200) {

                alert('Successfully Locked');
                fetchData();
            } else {
                const message = response.errorMessage || 'Submission failed. Please try again.';
                alert(message);
            }

        } catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            toast.error(message);
            console.error("Unhandled error:", message);
        } finally {
            setLoading(false);
        }
    };

    const downloadExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Payroll");
        XLSX.writeFile(wb, "Payroll.xlsx");
    };

    return (
        <div className="container mt-2 small-font">

            <h6 className="text-primary">Payroll Lock System</h6>

            <div className="row">
                <div className="col-md-2">
                    <label>Company</label>
                    <select className="form-select" onChange={(e) => setFilters({ ...filters, CompanyName: e.target.value })}>
                        <option value="">Select</option>
                        {company.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                </div>

                <div className="col-md-2">
                    <label>Plant</label>
                    <select className="form-select" onChange={(e) => setFilters({ ...filters, PlantName: e.target.value })}>
                        <option value="">Select</option>
                        {plants.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                    </select>
                </div>

                <div className="col-md-3">
                    <label>Vendor</label>
                    <select className="form-select" onChange={(e) => setFilters({ ...filters, VenderName: e.target.value })}>
                        <option value="">Select</option>
                        {vender.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
                    </select>
                </div>

                <div className="col-md-2">
                    <label>Employee Code</label>
                    <input className="form-control" onChange={(e) =>
                        setFilters({ ...filters, EmployeeCode: e.target.value })}
                    />
                </div>

                <div className="col-md-2">
                    <label>Month</label>
                    <input type="month" className="form-control" onChange={handleMonthChange} />
                </div>
            </div>

            <div className="mt-3 d-flex gap-2">
                <button className="btn btn-primary btn-sm" onClick={applyFilters}>Search</button>
                <button className="btn btn-success btn-sm" onClick={downloadExcel}>Export</button>
                <button
                    className="btn btn-info btn-sm"
                    onClick={() => applyStatusFilter("OPEN")}
                >
                    Open
                </button>
                <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => applyStatusFilter("LOCKED")}
                >
                    Locked
                </button>
                <button
                    className="btn btn-dark btn-sm"
                    onClick={() => applyStatusFilter("ALL")}
                >
                    All
                </button>
                <button className="btn btn-warning btn-sm" onClick={handleLockSelected}>Lock Selected</button>
            </div>

            <div className="table-container mt-3">
                <table className="table table-bordered table-sm text-nowrap">
                    <thead>
                        <tr>
                            <th><input type="checkbox" checked={selectAll} onChange={handleSelectAll} /></th>
                            <th>IsLock</th>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Plant</th>
                            <th>Department</th>
                            <th>Vendor</th>
                            <th>Total Days</th>
                            {/* <th>Worked Days</th> */}
                            <th>Present</th>
                            <th>Absent</th>
                            <th>PaidLeave</th>
                            <th>Half Day</th>
                            <th>WO</th>
                            <th>Holiday</th>
                            <th>TotalPaidDays</th>
                            <th>Total Hours</th>
                            <th>Incentive</th>
                            <th>Expected</th>
                            <th>Actual</th>
                            <th>Deducted</th>
                            <th>Pending Leave</th>
                            <th>Pending AR</th>
                            <th>ArrearDays</th>
                            <th>Pending OD</th>
                            <th>Sandwich</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredData.map(row => (
                            <tr key={row.code} className={row.isLock === 1 ? "table-danger" : ""}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={row.isLock === 1 || selectedRows.includes(row.code)}
                                        disabled={row.isLock === 1}
                                        onChange={() => handleRowSelect(row.code)}
                                    />
                                </td>
                                <td>{row.isLock === "1" ? "Locked" : "Open"}</td>
                                <td>{row.code}</td>
                                <td>{row.name}</td>
                                <td>{row.plantName}</td>
                                <td>{row.department}</td>
                                <td>{row.vendorName}</td>
                                <td>{row.totDays}</td>
                                {/* <td>{row.workedDays}</td> */}
                                <td>{row.presentDays}</td>
                                <td>{row.absent}</td>
                                <td>{row.paidLeave}</td>
                                <td>{row.halfDay}</td>
                                <td>{row.wo}</td>
                                <td>{row.holiday}</td>
                                <td>{row.totalPaidDays}</td>
                                <td>{row.totalHours}</td>
                                <td>{row.incentive}</td>
                                <td>{row.expected}</td>
                                <td>{row.actual}</td>
                                <td>{row.deducted}</td>
                                <td>{row.pendingLeave}</td>
                                <td>{row.pendingAR}</td>
                                <td>{row.arrearDays}</td>
                                <td>{row.pendingOD}</td>
                                <td>{row.sandwich}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PayRollGenerator;